import Form from 'src/utils/Form.js'

class OutgoingPaymentMethod extends Form {
  constructor(data, config = null) {
    super(data, config || Form.config)
  }

  fetch(then) {
    return super.get(`payment-methods/outgoing/${this.id}/edit`).then(data => {
      this.originalData = data
      for (let field in this.originalData) {
        this[field] = data[field]
      }
      then(data)
    })
  }

  static all(parameters, then) {
    return new Form().get(`payment-methods/outgoing?${parameters}`).then(then)
  }

  static list(currency_acronym, then) {
    return new Form().get(`payment-methods/outgoing/by/currency/${currency_acronym}`).then(then)
  }

  create(then) {
    return super.post(`payment-methods/outgoing`).then(then)
  }

  update(then) {
    return super.patch(`payment-methods/outgoing/${this.id}`).then(then)
  }

  destroy(then) {
    return super.delete(`payment-methods/outgoing/${this.id}`).then(then)
  }
}

export default OutgoingPaymentMethod
